import {useState} from 'react'

export type ProfileFilter = 'UNMATCHED' | 'MATCHED' | 'ALL'

export function useProfileFilter<
    ProfileType extends {photos?: any[] | null; idStr: string; fullName: string; createdAt: number}
>(profiles: ProfileType[], initialFilter: ProfileFilter = 'ALL') {
    const [filter, setFilter] = useState<ProfileFilter>(initialFilter)

    let filteredProfiles = profiles
    if (filter === 'UNMATCHED') filteredProfiles = profiles.filter((profile) => !profile.photos?.length)
    else if (filter === 'MATCHED') filteredProfiles = profiles.filter((profile) => !!profile.photos?.length)

    return {
        profiles: filteredProfiles,
        setFilter,
        filter,
    }
}
